{
  "accounts": {
    "current": "Du verwendest derzeit den folgenden Account: {{name}}",
    "signed_in": "Du bist derzeit als {{email}} angemeldet.",
    "switch_to": "Wechseln zu"
  },
  "error_page": {
    "403": {
      "description": "Du hast keine Berechtigung, auf diese Seite zuzugreifen.",
      "title": "403: Zugriff verweigert"
    },
    "404": {
      "description": "Die angeforderte Seite konnte nicht gefunden werden.",
      "title": "404: Seite nicht gefunden"
    },
    "422": {
      "description": "Deine Anfrage konnte nicht verarbeitet werden. Bitte lade die Seite neu und versuche es erneut.",
      "title": "422: Anfrage nicht verarbeitbar"
    },
    "500": {
      "description": "Ein unerwarteter Fehler ist aufgetreten. Bitte versuche es später erneut.",
      "title": "500: Serverfehler"
    },
    "503": {
      "description": "Der Dienst ist aufgrund von Wartungsarbeiten vorübergehend nicht verfügbar. Bitte versuche es in Kürze erneut.",
      "title": "503: Dienst nicht verfügbar"
    },
    "default": {
      "description": "Bei der Verarbeitung deiner Anfrage ist ein Fehler aufgetreten. Bitte versuche es später erneut.",
      "title": "Fehler {{status}}"
    }
  },
  "navigation": {
    "home": "Start",
    "sign_out": "Abmelden"
  },
  "passwords": {
    "back_to_login": "Zurück zur Anmeldung",
    "request": {
      "description": "Gib deine E-Mail-Adresse ein und wir senden dir Anweisungen zum Zurücksetzen.",
      "submit": "Anweisungen senden",
      "title": "Passwort vergessen?"
    },
    "reset": {
      "description": "Wähle ein neues Passwort für dein Konto.",
      "password": "Neues Passwort",
      "password_confirmation": "Neues Passwort bestätigen",
      "submit": "Passwort zurücksetzen",
      "title": "Passwort zurücksetzen"
    }
  },
  "session": {
    "description": "Melde dich mit deiner E-Mail-Adresse und deinem Passwort an.",
    "email_address": "E-Mail-Adresse",
    "forgot_password": "Passwort vergessen?",
    "have_invite_code": "Hast du einen Einladungscode?",
    "password": "Passwort",
    "sign_up": "Registrieren",
    "submit": "Anmelden",
    "title": "Anmelden"
  },
  "signup": {
    "back_to_login": "Zurück zur Anmeldung",
    "code": "Einladungscode",
    "description": "Gib deinen Einladungscode ein, um ein Konto zu erstellen.",
    "email_address": "E-Mail-Adresse",
    "first_name": "Vorname",
    "last_name": "Nachname",
    "password": "Passwort",
    "password_confirmation": "Passwort bestätigen",
    "submit": "Konto erstellen",
    "title": "Konto erstellen"
  },
  "attributes": {
    "created_at": "Erstellt",
    "discarded_at": "Verworfen"
  }
}
